import {Injectable} from '@angular/core';
import {Graphql} from './graphql';
import {CareerProfileDto} from '../dto/career-profile-dto';
import {
  createCareerProfile,
  removeCareerProfile,
  retrieveCareerProfileById,
  retrieveCareerProfilesByIds,
  retrieveCareerProfilesByQuery,
  retrieveCareerProfilesBySectorId,
  retrieveCareerProfilesBySectorIdAndCompanyId,
  updateCareerProfile
} from '../graphql/career-profile.graphql';

@Injectable({
  providedIn: 'root'
})
export class CareerProfile extends Graphql {

  public retrieveCareerProfilesBySectorId(sectorId: string, page: number, size: number, fields: string[] = ['id']) {
    return this.query<CareerProfileDto[]>(retrieveCareerProfilesBySectorId(fields), {
      sectorId: sectorId,
      page: page,
      size: size
    }, "retrieveCareerProfilesBySectorId");
  }

  public retrieveCareerProfileById(id: string, fields: string[] = ['id']) {
    return this.query<CareerProfileDto>(retrieveCareerProfileById(fields), {id: id}, "retrieveCareerProfileById");
  }

  public createCareerProfile(careerProfile: CareerProfileDto, fields: string[] = ['id']) {
    return this.mutation<CareerProfileDto>(createCareerProfile(fields), {careerProfile: careerProfile}, "createCareerProfile");
  }

  public updateCareerProfile(careerProfile: CareerProfileDto, fields: string[] = ['id']) {
    return this.mutation<CareerProfileDto>(updateCareerProfile(fields), {careerProfile: careerProfile}, "updateCareerProfile");
  }

  public retrieveCareerProfilesBySectorIdAndCompanyId(sectorId: string, companyId: string, size: number = -1, fields: string[] = ['id'], includeId?: string) {
    return this.query<CareerProfileDto[]>(retrieveCareerProfilesBySectorIdAndCompanyId(fields), {
      sectorId: sectorId,
      companyId: companyId,
      size: size,
      includeId: includeId
    }, "retrieveCareerProfilesBySectorIdAndCompanyId");
  }

  public retrieveCareerProfilesByQuery(query: string, sectorId: string, companyId: string, size: number, fields: string[] = ['id']) {
    return this.query<CareerProfileDto[]>(retrieveCareerProfilesByQuery(fields), {
      query: query,
      sectorId: sectorId,
      companyId: companyId,
      size: size
    }, "retrieveCareerProfilesByQuery");
  }

  public retrieveCareerProfilesByIds(ids: string[], fields = ['id']) {
    return this.query<CareerProfileDto[]>(retrieveCareerProfilesByIds(fields), {ids: ids}, "retrieveCareerProfilesByIds");
  }

  public removeCareerProfile(id: string) {
    return this.mutation<boolean>(removeCareerProfile(), {id: id}, "removeCareerProfile");
  }
}
